export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface ClientSortFilterType {
  sortOption: SortFilterOption<server.dto.ClientSort>
}

export const DefaultClientSortFilter: server.dto.ClientSort = "nameAsc"

export const ClientSortOptions: Array<SortFilterOption<server.dto.ClientSort>> = [
  {
    label: RESX.GeneralLabels.Name,
    value: "nameAsc",
    enabled: true
  },
  {
    label: RESX.Subscription.Renewal,
    value: "renewalDesc",
    enabled: true
  },
  {
    label: "Customer since",
    value: "customerSinceAsc",
    enabled: true
  },
  {
    label: "Customer churn",
    value: "customerChurnDesc",
    enabled: true
  },
  {
    label: "Annual worth",
    value: "annualWorthDesc",
    enabled: true
  },
];

export const getSortOption = (value: server.dto.ClientSort) => {
  return ClientSortOptions.find(s => s.value === value);
};

export const initialClientSortFilter: ClientSortFilterType = {
  sortOption: getSortOption(DefaultClientSortFilter)
};
